import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierActivityList extends Layout {
    layoutheaderCarrierActivityList: LayoutHeader;
    sourceCarrierActivity: DataSource;
    tableCarrierActivities: Table;
}
